<template>
    <b-modal :id="'modal-edit-review-' + prefix" modal-class="modal-w-md modal-rating">
        <template #modal-header>
            <h5 v-if="review.isNew" class="modal-title">Ratings</h5>
            <h5 v-else class="modal-title">Edit Review</h5>
            <a v-if="!review.isNew" class="link" @click="deleteReview">Delete Review</a>
            <button @click="close()" class="close"></button>
        </template>
        
        <div class="rating-section mb-2">
            <h5 class="heading5 heading5--secondary">Your rating:</h5>
            <div class="rating rating-modal">
                <span :class="{'rating__current': review.interestLevel >= 1}" @click="review.interestLevel = 1"></span>
                <span :class="{'rating__current': review.interestLevel >= 2}" @click="review.interestLevel = 2"></span>
                <span :class="{'rating__current': review.interestLevel >= 3}" @click="review.interestLevel = 3"></span>
                <span :class="{'rating__current': review.interestLevel >= 4}" @click="review.interestLevel = 4"></span>
                <span :class="{'rating__current': review.interestLevel >= 5}" @click="review.interestLevel = 5"></span>
            </div>
        </div>

        <span v-if="review.messageError.length" class="error">{{review.messageError}}</span>
        <textarea class="form-control--mid form-control" v-model="review.message">

        </textarea>

        <div v-for="(field, index) in review.reviewerFields" :key="index" class="mt-2 mb-4">
            <h5 class="heading5 heading5--secondary">{{field.field.name}}</h5>

            <span v-if="field.error.length" class="error">{{field.error}}</span>

            <custom-field
                :field="review.reviewerFields[index].field"
                :value="review.reviewerFields[index].value"
                :inline="false"
                :instantUpdate="false"
                :index="index"
                v-on:customValueChanged="reviewerValueChanged"
            >
            </custom-field>
        </div>

        <template #modal-footer>
            <b-button variant="primary" size="lg" :disabled="review.interestLevel == 0" @click="save">Save</b-button>
        </template>

    </b-modal>
</template>

<script>
import trackersReviews from "@/services/trackers-reviews.service";
import CustomField from "@/components/customFields/CustomField";

export default {
    components: {
        CustomField
    },

    props: {
        prefix: String
    },

    data() {
        return {
            trackerId: 0,
            companyId: 0,

            review: {
                message: '',
                messageError: '',
                interestLevel: 0,
                isNew: true,
                reviewerFields: [],
            },

            fieldFilesNumber: 0
        }
    },

    methods: {
        init() {
            this.review.message = ""
            this.review.messageError = ""
            this.review.interestLevel = 0
            this.review.reviewerFields = []

            trackersReviews.getEdit(this.trackerId, this.companyId).then(result => {
                this.review.message = result.data.message
                this.review.interestLevel = result.data.interest_level
                this.review.isNew = result.data.is_new
                result.data.reviewer_fields = this.arrayHelper.addColumn(result.data.reviewer_fields, 'error', '')
                this.review.reviewerFields = result.data.reviewer_fields
            })
        },

        open(trackerId, companyId) {
            this.trackerId = trackerId
            this.companyId = companyId

            this.init()
            this.$bvModal.show('modal-edit-review-' + this.prefix)
        },

        close() {
            this.$bvModal.hide('modal-edit-review-' + this.prefix)
        },

        reviewerValueChanged({index, value}) {
            this.review.reviewerFields[index].value = value

            if (this.review.reviewerFields[index].field.type === 'date') {
                this.review.reviewerFields[index].value.value = this.dateHelper.decodeDate(this.review.reviewerFields[index].value.value)
            }
        },

        save() {
            let hasErrors = false

            this.review.messageError = ''

            if (!this.review.message.length) {
                this.review.messageError = 'This field is mandatory'
                hasErrors = true
            }

            for (let i in this.review.reviewerFields) {

                this.review.reviewerFields[i].error = ''

                if (this.review.reviewerFields[i].required) {
                    if (!this.stringHelper.fieldFilled(this.review.reviewerFields[i].value)) {
                        this.review.reviewerFields[i].error = 'This field is mandatory'
                        hasErrors = true
                    }
                }

                if (this.review.reviewerFields[i].field.type == 'numeric' && this.review.reviewerFields[i].value.value &&
                    (this.review.reviewerFields[i].value.value < this.review.reviewerFields[i].field.min_value || this.review.reviewerFields[i].value.value > this.review.reviewerFields[i].field.max_value)) {
                    this.review.reviewerFields[i].error = 'Field value must be between ' + this.review.reviewerFields[i].field.min_value + ' and ' + this.review.reviewerFields[i].field.max_value
                    hasErrors = true
                }
            }

            if (!hasErrors) {
                trackersReviews.save(this.trackerId, this.companyId, this.review).then(() => {
                    this.fieldFilesNumber = this.fileHelper.fieldsWithNewFilesNumber(this.review.reviewerFields)

                    if (this.fieldFilesNumber) {
                        this.review.reviewerFields.forEach(field => {

                            let formData = new FormData();
                            let hasFiles = false

                            field.value.files.forEach(file => {
                                if (file.id == 0) {
                                    formData.append('file[]', file)
                                    hasFiles = true
                                }
                            })

                            if (hasFiles) {
                                trackersReviews.saveFiles(this.trackerId, this.companyId, field.field.id, formData).then(() => {
                                    this.fieldFilesSaved()
                                })
                            }
                        })
                    } else {
                        this.$emit('reviewSaved', this.companyId)
                        this.$bvModal.hide('modal-edit-review-' + this.prefix)
                    }
                })
            }
        },

        deleteReview() {
            if (confirm('Delete Review?')) {
                trackersReviews.delete(this.trackerId, this.companyId).then(() => {
                    this.$emit('reviewSaved', this.companyId)
                    this.$bvModal.hide('modal-edit-review-' + this.prefix)
                })
            }
        },

        fieldFilesSaved() {
            --this.fieldFilesNumber

            if (!this.fieldFilesNumber) {
                this.$emit('reviewSaved', this.companyId)
                this.$bvModal.hide('modal-edit-review-' + this.prefix)
            }
        },
    }
}
</script>

<style scoped>

</style>
